/**
 * ResellerChargeChip (TMMPDM-0037, STATE-001/002/003) — a reseller charge's status in words, the
 * same chip everywhere it shows: the Billing tab, a Standing month's shortfall charge, a charged
 * settlement and the run sheet. The tone is the registry's (`StatusChip`, TMMPDM-0065): SUCCEEDED
 * → success, FAILED → error, REQUIRES_ACTION → warning, PENDING / REQUESTED → info. A status this
 * console doesn't know renders neutrally with its raw value rather than throwing.
 */
import { useCopy } from '@/hooks/useCopy';
import { StatusChip } from '@/status';
import type { ResellerChargeStatus } from '@/api/tmm/types';
import { CHARGE_STATUS_FALLBACK } from './settlementFormat';

export function ResellerChargeChip({ status }: { status: string }) {
  const { t } = useCopy();
  if (!Object.hasOwn(CHARGE_STATUS_FALLBACK, status)) {
    return <StatusChip label={status} />;
  }
  return (
    <StatusChip
      status={status}
      label={t(
        `resellerBilling.chargeStatus.${status}`,
        CHARGE_STATUS_FALLBACK[status as ResellerChargeStatus],
      )}
    />
  );
}
